
import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class SharingVendorFileId extends IdValueObject {
  static create(value: string): SharingVendorFileId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new SharingVendorFileId(value);
  }
}
